import { Progress, Button } from "antd";
import Layout from 'Layout'
import './CreditYour.scss'

export default function SubscriptionPanel() {
  return (
    <Layout>
      <div className="credit-your w-full px-6 py-10">

        {/* ==== TOP SECTION ==== */}
        <div className="flex flex-col justify-between items-start md:flex-row">

          {/* Left Info */}
          <div>
            <h2 className="text-[22px] font-semibold mb-2">
              Subscription & Tokens
            </h2>

            <p className="text-sm sub-text mb-8">
              Your next token refill of <strong>10M tokens</strong> is due on{" "}
              <strong>December 17, 2025</strong>.
            </p>

            {/* Current token balance */}
            <div className="mb-6">
              <p className="sub-text text-sm mb-1">Current token balance</p>
              <p className="text-[42px] font-semibold leading-none">10.4M</p>
            </div>

            {/* Rolled-over tokens */}
            <p className="text-sm sub-text mb-6">
              <strong>0 rolled-over tokens</strong> — Expiring on December 17, 2025.
            </p>

            {/* Monthly tokens */}
            <div className="mb-4">
              <p className="text-sm font-medium mb-1">
                9.4M/10M monthly tokens
                <span className="sub-text font-normal">
                  {" "}Unused tokens will roll over and expire January 17, 2026.
                </span>
              </p>

              {/* Blue progress bar */}
              <div className="w-full h-[10px] bg-[#3e3e3e] rounded-full relative overflow-hidden mb-4">
                <div className="absolute top-0 left-0 h-full bg-[#2b83ff] w-[94%] rounded-full"></div>
              </div>
            </div>
          </div>

          {/* Right Profile */}
          <div className="flex gap-[8px] items-center">
            <div className="w-[50px] h-[50px] rounded-full bg-[#d14cff] text-white flex items-center justify-center text-xl font-bold">
              H
            </div>
            <div className="">
              <p className="sub-text mt-2 text-sm">Pro plan</p>
              <p className="text-sm font-medium mt-1">huanpc1989@gmail.com</p>
            </div>
          </div>
        </div>

        {/* ==== UPGRADE BOX ==== */}
        <div className="flex-col justify-between card border rounded-xl mt-8 p-7 sm:flex">

          <div>
            <h3 className="text-lg font-semibold mb-2">Get more out of Pro</h3>

            <p className="sub-text text-sm max-w-[650px] mb-4 leading-relaxed">
              Switch to the next tier and receive{" "}
              <strong>26M tokens per month.</strong>
            </p>
          </div>

          <div className="flex flex-col gap-[8px] items-end">
            <div className="flex items-center gap-[8px]">
              <p className="text-[32px] font-semibold">$50</p>
              <p className="sub-text -mt-1">per month <br /> billed monthly</p>
            </div>

            <Button
              type="primary"
              size="large"
              className="px-8 py-5 text-base font-medium"
            >
              Upgrade plan
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
